
const getPainidsArray = (spid,visitReasonList) => {
    let selectedSp = visitReasonList.filter((s => s.specialtyId== spid&&s.painId!==null))
    selectedSp=selectedSp.map((sp)=>parseInt(sp.painId))
    return selectedSp
}
export default {getPainidsArray}
